import React from 'react';
import "./Error.css"
const Error = () => {
    return (
        <div className="error-container  d-flex justify-content-center align-items-center">
            <div>
                <h1>Page Not Found!</h1>

            </div>
        </div>
    );
};

export default Error;